import React from 'react';
import client from '../tina/__generated__/client';
import { AgbQuery, Exact } from '../tina/__generated__/types';
import { useTina } from 'tinacms/dist/react';
import { Heading } from 'shared/Typography';
import { Section } from 'react-headings';
import { Flex } from 'components/atoms/Flex';
import { ContentCenter14 } from '../components/organisms/ContentCenter14/ContentCenter14';
import { MarkdownWithTypo } from '../components/organisms/MarkdownWithTypo/MarkdownWithTypo';
import { NextSeo, NextSeoProps } from 'next-seo';

export default function ServicesAndPrices(props: {
  data: AgbQuery;
  query: string;
  variables: Exact<{ relativePath: string }>;
}) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  return (
    <>
      <NextSeo {...(data.agb.seo as NextSeoProps)} />
      <Flex
        css={{
          flexDirection: 'column',
          paddingInline: '$spacingMainMobile',
          paddingBlock: '$spacing-5x',
          '@tabletAndUp': {
            paddingBlock: 0,
          },
        }}
      >
        <Flex
          css={{
            flexDirection: 'column',
            maxWidth: '$textContent',
            margin: 'auto',
            gap: '$spacing-3x',
            alignContent: 'stretch',
            justifyContent: 'center',
            width: '100%',
            '@tabletAndUp': {
              gap: '$spacing-3x',
              paddingBlock: '$spacing-8x',
            },
          }}
        >
          <Section
            component={
              <Heading
                variant={{ '@initial': 'h2', '@tabletAndUp': 'h2TabletAndUp' }}
              >
                {data.agb?.headline}
              </Heading>
            }
          >
            <Flex
              css={{
                width: '100%',
                maxWidth: '$textContent',
                margin: 'auto',
              }}
            >
              <MarkdownWithTypo content={data.agb?.content} />
            </Flex>
          </Section>
        </Flex>
      </Flex>

      <ContentCenter14
        content={data.agb?.agbAustriaDownloadContent}
        label={data.agb?.agbAustriaDownloadLinkLabel}
        href={data.agb?.agbAustriaDownloadLinkHref}
      />
      <ContentCenter14
        content={data.agb?.agbGermanyDownloadContent}
        label={data.agb?.agbGermanyDownloadLinkLabel}
        href={data.agb?.agbGermanyDownloadLinkHref}
      />
    </>
  );
}

export const getStaticProps = async () => {
  const pageResponse = await client.queries.agb({
    relativePath: 'agb.mdx',
  });

  return {
    props: {
      data: pageResponse.data,
      query: pageResponse.query,
      variables: pageResponse.variables,
    },
  };
};
